import { Component, computed, inject, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import {
  ApplicantAppEntityApplicantWrite,
  ApplicantAppEntityApplicationRead, EntityTypeAppEntityDictionaryEntityType
} from '../../../../../../../openapi';
import { Store } from '@ngrx/store';
import { selectEntityTypes } from '../../../../../../../store/selectors/application.selectors';

@Component({
  selector: 'app-applicant-item-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent
  ],
  templateUrl: './applicant-item-preview.component.html'
})
export class ApplicantItemPreviewComponent {

  @Input()
  public applicant: ApplicantAppEntityApplicantWrite | ApplicantAppEntityApplicationRead | undefined;

  private store$: Store = inject(Store);

  private entityTypes: Signal<EntityTypeAppEntityDictionaryEntityType[]> = this.store$.selectSignal(selectEntityTypes);

  public get isNaturalPerson(): Signal<boolean> {
    return computed(() => {
      const types = this.entityTypes();
      const entityType: any = this.applicant?.entityType;
      if (typeof entityType === 'object') {
        return types.filter(v => v.id === entityType.id).at(0)?.code === 'OSOBA_FIZYCZNA';
      } else {
        return types.filter(v => v.id === entityType).at(0)?.code === 'OSOBA_FIZYCZNA';
      }
    });

  }
}
